import { render, staticRenderFns } from "./use.vue?vue&type=template&id=2c541fd8&scoped=true&"
import script from "./use.vue?vue&type=script&lang=js&"
export * from "./use.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c541fd8",
  null
  
)

export default component.exports